import {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {Button, Spin, Table, message, Space} from 'antd';
import {GradeUI} from './GradeTypes';
import {GradesService} from './GradesService';
import Title from 'antd/es/typography/Title';

const gradesService = new GradesService();

export const GradesTable = () => {
  const [grades, setGrades] = useState<GradeUI[]>([]);
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    gradesService
      .getGrades()
      .then(resp => {
        setIsLoading(false);
        setGrades(resp);
      })
      .catch(error => {
        setIsError(true);
        console.error('Error fetching grades:', error);
      });
  }, []);

  const handleDelete = async (id: string) => {
    try {
      setIsLoading(true);
      await gradesService.deleteNewGrade(id);
      message.success('Grade deleted successfully');
      const updatedGrades = await gradesService.getGrades();
      setGrades(updatedGrades);
      setIsLoading(false);
    } catch (error) {
      message.error('Failed to delete grade');
      setIsLoading(false);
    }
  };

  const columns: any = [
    {
      title: 'Name',
      dataIndex: ['name'],
      render: (name: string, record: GradeUI) => (
        <Link to={'/grades/' + record._id + '/edit'}>{name}</Link>
      ),
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
    },
    {
      title: 'Arabic Name',
      dataIndex: ['arabicName'],
    },
    {
      title: 'ID',
      dataIndex: '_id',
      render: (id: string) => <Link to={'/grades/' + id + '/edit'}>{id}</Link>,
    },
    {
      title: 'Actions',
      key: 'actions',
      dataIndex: '_id',
      render: (id: string) => (
        <Space>
          <Link to={'/grades/' + id + '/edit'}>
            <Button>Edit</Button>
          </Link>
          {/* Deletion logic is often commented out in this project */}
        </Space>
      ),
    },
  ];

  return (
    <>
      <Button size={'large'} style={{float: 'right', margin: 20}}>
        <Link to={'/grades/create'}>Create</Link>
      </Button>
      {!isError && !isLoading && (
        <Table
          pagination={{defaultPageSize: 100}}
          columns={columns}
          dataSource={grades}
          rowKey="_id"
        />
      )}
      {isLoading && (
        <Spin size="large" style={{margin: 'auto', width: '100%'}} />
      )}
      {isError && <Title>Grades fetching error ⚠️</Title>}
    </>
  );
};
